<h2 mat-dialog-title>Editar datos del vídeo</h2>

<mat-dialog-content [formGroup]="form" class="modal-content">
  <mat-form-field appearance="outline">
    <mat-label>Título</mat-label>
    <input matInput formControlName="title" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Temporada</mat-label>
    <mat-select formControlName="season_id">
      <mat-option [value]="1">Temporada actual (ID 1)</mat-option>
      @for (season of data.seasons; track season.id) {
        <mat-option [value]="season.id">{{ season.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Fecha del partido</mat-label>
    <input matInput type="date" formControlName="match_date" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Competición</mat-label>
    <mat-select formControlName="competition_id">
      @for (competition of data.competitionOptions; track competition.id) {
        <mat-option [value]="competition.id">{{ competition.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Categoría</mat-label>
    <mat-select formControlName="category_id">
      @for (category of data.categoryOptions; track category.id) {
        <mat-option [value]="category.id">{{ category.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Género</mat-label>
    <mat-select formControlName="gender">
      @for (gender of data.genderOptions; track gender.id) {
        <mat-option [value]="gender.name">{{ gender.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid">Guardar</button>
</mat-dialog-actions>
